import { IQuestionAnswerPagedRequest } from '../../../../model/apm/question-answer/request/question-answer-paged-request';
import { IQuestionAnswerCategoryResponse } from '../../../../model/apm/question-answer/response/question-answer-category-response';
import { IQuestionAnswerResponse } from '../../../../model/apm/question-answer/response/question-answer-response';

export type QuestionAnswerSearchState = {
    parameters: IQuestionAnswerPagedRequest;
    searchTrigger: number;
    categories: IQuestionAnswerCategoryResponse[];
    drawer: { open: boolean; questionAnswer?: IQuestionAnswerResponse };
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    triggerSearch = 'triggerSearch',
    setCategories = 'setCategories',
    openDrawer = 'openDrawer',
    closeDrawer = 'closeDrawer',
}

export const QuestionAnswerSearchReducer = (state: QuestionAnswerSearchState, action: any): QuestionAnswerSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        case ACTION_TYPES.setCategories:
            return { ...state, categories: payload };
        case ACTION_TYPES.openDrawer:
            return { ...state, drawer: { open: true, questionAnswer: payload } };
        case ACTION_TYPES.closeDrawer:
            return { ...state, drawer: { open: false } };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
